<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-page-heading *ngIf="!!setting" [ttModel]="setting.page_heading"></tt-page-heading>

    <tt-card>
        <tt-button-goto ttText="activitytypeactstatuses_new_actstatus" ttGoto="actstatus" [ttGotoParms]="{ actstatus_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListStatuses" ttBadge="badgeinfo"></tt-list>
</tt-page>
